import { Controller, useForm } from "react-hook-form";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { CountrySelector, FormContainer, TextInput } from "../shared";
import { RegexPattern, clearCache } from "../../utils";

const VeevaForm = ({ formData, formType, query }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            veevaId: formData?.veevaId || "",
            title: formData?.title || "",
            country: formData?.country.toUpperCase() || "",
        },
    });

    const { submitMutation, loading } = useGlobalMutation(query, (cache) => {
        clearCache(cache, "allVeevaData");
    });

    const handleSubmission = async (data) => {
        const { veevaId, title, country } = data;

        const variables =
            formType === "update"
                ? {
                      id: formData.id,
                      veevaDatumPatch: {
                          veevaId,
                          title,
                          country,
                      },
                  }
                : {
                      veevaId: [veevaId],
                      title: [title],
                      country: [country],
                  };

        const dataPath =
            formType === "update" ? "updateVeevaDatumById.veevaDatum" : "veevaDataInsert.veevaData";

        const isResultNull = await submitMutation(
            variables,
            dataPath,
            `Veeva ID ${formType === "update" ? "Updated" : "Created"} Successfully`
        );
        isResultNull === null && formType !== "update" && reset();
    };

    return (
        <FormContainer
            submitAction={handleSubmit(handleSubmission)}
            loading={loading}
            submitButtonText={`${formType === "update" ? "Update" : "Create"} Veeva ID`}
            submitBtnSm={formType === "update"}
        >
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="veevaId"
                        labelText="Veeva ID"
                        {...register("veevaId", {
                            pattern: RegexPattern.nameWithoutSpace,
                            required: true,
                        })}
                        isInvalid={!!errors.veevaId}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="title"
                        labelText="Title"
                        {...register("title", {
                            pattern: RegexPattern.name,
                            required: true,
                        })}
                        isInvalid={!!errors.title}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <Controller
                        name="country"
                        render={({ field: { onChange, value }, ref }) => (
                            <CountrySelector
                                id="country"
                                country={value || ""}
                                labelText="Country"
                                selectCountry={onChange}
                                {...register("country", {
                                    required: true,
                                })}
                                required
                                isInvalid={!!errors.country}
                                ref={ref}
                            />
                        )}
                        control={control}
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default VeevaForm;
